const NUBBIN_OFFSET_PX = 16;
const ELEMENT_OFFSET_PX = 4;
const getNubbinOffset = ({
  type,
  withNubbin
}) => {
  if (type === "popover") {
    return NUBBIN_OFFSET_PX + (withNubbin ? ELEMENT_OFFSET_PX : ELEMENT_OFFSET_PX * -3);
  }
  return ELEMENT_OFFSET_PX * (withNubbin ? 1 : -3);
};
const getElementOffset = ({
  type,
  position
}) => {
  if (type === "popover") {
    return position === "left" || position === "right" ? NUBBIN_OFFSET_PX * 2 : 0;
  }
  return NUBBIN_OFFSET_PX * (position === "left" || position === "right" ? 3 : 1);
};
const calculatePosition = ({
  type,
  target,
  position,
  withNubbin
}) => {
  if (typeof window === "undefined" || typeof (window == null ? void 0 : window.matchMedia) !== "function") {
    return void 0;
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
    return void 0;
  }
  const {
    top: targetTop,
    left: targetLeft,
    width: targetWidth,
    right: targetRight,
    height: targetHeight
  } = target;
  const targetOffsetTop = targetTop + window.pageYOffset;
  const nubbinOffset = getNubbinOffset({ type, withNubbin });
  const elementOffset = getElementOffset({ type, position });
  switch (position) {
    default:
    case "bottom_center":
      return {
        position: "absolute",
        top: `${targetOffsetTop + targetHeight + nubbinOffset}px`,
        left: `${targetLeft + targetWidth * 0.5 - elementOffset}px`,
        transform: "translate(-50%, 0)"
      };
    case "bottom_left":
      return {
        position: "absolute",
        top: `${targetOffsetTop + targetHeight + nubbinOffset}px`,
        left: `${targetLeft - elementOffset}px`
      };
    case "bottom_right":
      return {
        position: "absolute",
        top: `${targetOffsetTop + targetHeight + nubbinOffset}px`,
        right: `calc(100% - ${targetRight + elementOffset}px)`
      };
    case "left":
      return {
        position: "absolute",
        right: `calc(100% - ${targetLeft - nubbinOffset}px)`,
        top: `${targetOffsetTop + targetHeight * 0.5 - elementOffset}px`
      };
    case "right":
      return {
        position: "absolute",
        left: `${targetLeft + targetWidth + nubbinOffset}px`,
        top: `${targetOffsetTop + targetHeight * 0.5 - elementOffset}px`
      };
  }
};
var calculatePosition_default = calculatePosition;
export {
  ELEMENT_OFFSET_PX,
  NUBBIN_OFFSET_PX,
  calculatePosition_default as default,
  getElementOffset,
  getNubbinOffset
};
